<template>
  <div>
    <h1>Dashboard</h1>
    <div style="display:flex;width:20rem;justify-content:space-evenly;">
      <router-link :to="{ name: 'Home' }">+Companies</router-link>
      <router-link :to="{ name: 'Test' }">+Testing</router-link>
    </div>
    <Tag :text="'Test'" light />
  </div>
</template>

<script>
import Tag from '@/components/Tag'

export default {
  components: { Tag },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/fontstyles';
.router-link-exact-active.router-link-active {
  @include navbar-item-font--active();
}
</style>
